/* Nordic Weaving: prisformatet på favoritsiden. 11/9-2026.

   Resten af sitet skriver 649,00 kr. Favoritsiden skrev 649 kr. Målt samme
   dag: kurvens Gemt til senere 649,00 kr, produktsiden 379,00 kr,
   produktkortene Fra 449,00 kr. Favoritsiden var den eneste undtagelse, så
   det er den der rettes.

   Hvorfor det ligger her og ikke i sektionen: priserne skrives af
   sections/nw-wishlist-page.liquid, som fylder 31 KB, og en themeFilesUpsert
   er en fuld overskrivning uden versionshistorik. Flyttes ind ved
   oprydningen, opgave 217.

   VI RETTER KUN DET DER MANGLER KOMMA. Uden den regel ville en pris blive
   formateret om igen ved hver gentegning, og 649,00 ville før eller siden
   blive til noget andet. Derfor kræver mønsteret nedenfor at der IKKE er et
   komma i forvejen. */
(function (w, d) {
  'use strict';

  /* Tal med tusindpunktum og uden decimaler, efterfulgt af kr.
     1.298 kr og 649 kr rammes. 649,00 kr rammes IKKE. */
  var MOENSTER = /(^|[\s(])(\d{1,3}(?:\.\d{3})*)\s*kr\b/g;

  function rettetTekst(t) {
    return t.replace(MOENSTER, function (helt, foer, tal) {
      return foer + tal + ',00 kr';
    });
  }

  function rettElement(el) {
    if (!el) return;
    /* Kun tekstknuder. Rører vi innerHTML, mister vi <s> om førprisen og de
       lyttere sektionen har sat på knapperne. */
    var gaa = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var knude, liste = [];
    while ((knude = gaa.nextNode())) liste.push(knude);
    for (var i = 0; i < liste.length; i++) {
      var ny = rettetTekst(liste[i].nodeValue);
      if (ny !== liste[i].nodeValue) liste[i].nodeValue = ny;
    }
  }

  function rettAlle() {
    var felter = d.querySelectorAll('.nw-wl__price, .nw-wl__sub, .nw-wl__total, .nw-wl__btn');
    for (var i = 0; i < felter.length; i++) rettElement(felter[i]);
  }

  function start() {
    var rod = d.querySelector('.nw-wl');
    if (!rod) return;
    rettAlle();

    /* Listen tegnes om når man lægger i kurven eller fjerner en vare, og så
       er de nye priser uformaterede igen. Derfor en observatør frem for et
       enkelt kald ved indlæsning. Den er afgrænset til .nw-wl, så den ikke
       lytter på hele siden. */
    if (!w.MutationObserver) return;
    var venter = null;
    new w.MutationObserver(function () {
      clearTimeout(venter);
      venter = setTimeout(rettAlle, 60);
    }).observe(rod, { childList: true, subtree: true, characterData: true });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
}(window, document));
